import styled, { DefaultTheme } from 'styled-components';

export const Container = styled.div<{ spL?: number }>`
  padding: 1rem 0;
  width: 100%;
  height: auto;
  position: relative !important;
  margin-top: auto;
  font-size: 0.8rem;
  display: flex;
  font-weight: 600;
  > p {
    position: absolute;
    z-index: 100;
    bottom: 3rem !important;
  }

  span {
    position: absolute;
    bottom: 6rem;
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 1rem;
    text-align: center;
  }

  span:nth-of-type(1) {
    bottom: 8.5rem;
  }
  span:nth-of-type(2) {
    bottom: 5rem;
  }
`;

const returnColor = (theme: DefaultTheme, type: 'debt' | 'hired' | 'spent') => {
  switch (type) {
    case 'debt':
      return theme.colors[2400];
    case 'spent':
      return theme.colors[300];
    default:
      return theme.colors[800];
  }
};

export const ColoBar = styled.div<{ widthPercentage: number; type: 'debt' | 'hired' | 'spent' }>`
  color: ${({ theme }) => theme.colors[1300]};
  background-color: ${({ theme, type }) => returnColor(theme, type)};
  width: ${({ widthPercentage }) => widthPercentage}%;
  text-align: center;
  font-weight: 600;
  margin: -0.5rem 0;
  padding: 0.5rem 0;
  position: relative;
  display: ${({ widthPercentage }) => (widthPercentage ? 'block' : 'none')};
  ::before {
    position: absolute;
    content: ' ';
    top: 50%;
    bottom: 50%;
    left: 0;
    margin-top: auto;
    margin-bottom: auto;
    width: 0.2px;
    height: calc(100% + 20px);
    background-color: ${({ theme }) => theme.colors[900]};
  }
  ::after {
    display: ${({ type }) => (type === 'spent' ? 'none' : 'block')};
    position: absolute;
    content: ' ';
    top: 50%;
    bottom: 50%;
    right: 0;
    margin-top: auto;
    margin-bottom: auto;
    width: 0.2px;
    height: calc(100% + 20px);
    background-color: ${({ theme }) => theme.colors[900]};
  }
`;
